module.exports = __webpack_public_path__ + "static/media/word.50cb0654.svg";